import { useEffect, useCallback, useRef } from "react";

type BackButtonCallback = () => boolean | void;

const useBackButton = (
  callback: BackButtonCallback,
  deps: React.DependencyList = [],
): void => {
  // 메모이제이션된 콜백 참조 저장
  const callbackRef = useRef<BackButtonCallback>(callback);

  // 콜백 핸들러를 메모이제이션
  const handleBackButton = useCallback((event: PopStateEvent): void => {
    const result = callbackRef.current?.();
    if (result === true) {
      event.preventDefault();
      event.stopImmediatePropagation();
      // 브라우저 히스토리 상태 유지
      window.history.pushState(null, "", window.location.pathname);
    }
  }, []);

  // 콜백 업데이트
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback, ...deps]);

  // 이벤트 리스너 설정
  useEffect(() => {
    // 초기 히스토리 상태 설정
    // window.history.pushState(null, "", window.location.pathname);

    // 이벤트 리스너 등록
    window.addEventListener("popstate", handleBackButton, { passive: false });

    // 클린업 함수
    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [handleBackButton]);

  useEffect(() => {
    // 초기 히스토리 상태 설정
    window.history.pushState(null, "", window.location.pathname);
  }, []);
};

export default useBackButton;
